import {
  RECORD_CLUSTER_COUNT_LAYER_ID,
  RECORD_CLUSTER_LAYER_ID,
  RECORD_LABEL_LAYER_ID,
  RECORD_POINT_LAYER_ID,
  RECORD_SOURCE_ID,
  recordClusterCountLayerDefinition,
  recordClusterLayerDefinition,
  recordFeatureCollection,
  recordLabelLayerDefinition,
  recordPointLayerDefinition,
  recordSourceDefinition
} from './record_layer'

export const useRecordLayer = ({
  getMap,
  isReady,
  getOpportunities,
  getParcels,
  getSelectedRecord,
  onSelectRecord,
  emptyFeatureCollection
}) => {
  const sync = () => {
    if (!isReady()) return

    ensure()
    getMap().getSource(RECORD_SOURCE_ID)?.setData(recordFeatureCollection({
      opportunities: getOpportunities(),
      parcels: getParcels(),
      selectedRecord: getSelectedRecord()
    }))
  }

  const ensure = () => {
    const map = getMap()
    if (!map.getSource(RECORD_SOURCE_ID)) {
      map.addSource(RECORD_SOURCE_ID, recordSourceDefinition(emptyFeatureCollection()))
    }
    if (!map.getLayer(RECORD_CLUSTER_LAYER_ID)) {
      map.addLayer(recordClusterLayerDefinition())
      map.on('click', RECORD_CLUSTER_LAYER_ID, handleClusterClick)
      map.on('mouseenter', RECORD_CLUSTER_LAYER_ID, () => { map.getCanvas().style.cursor = 'pointer' })
      map.on('mouseleave', RECORD_CLUSTER_LAYER_ID, () => { map.getCanvas().style.cursor = '' })
    }
    if (!map.getLayer(RECORD_CLUSTER_COUNT_LAYER_ID)) {
      map.addLayer(recordClusterCountLayerDefinition())
    }
    if (!map.getLayer(RECORD_POINT_LAYER_ID)) {
      map.addLayer(recordPointLayerDefinition())
      map.on('click', RECORD_POINT_LAYER_ID, handlePointClick)
      map.on('mouseenter', RECORD_POINT_LAYER_ID, () => { map.getCanvas().style.cursor = 'pointer' })
      map.on('mouseleave', RECORD_POINT_LAYER_ID, () => { map.getCanvas().style.cursor = '' })
    }
    if (!map.getLayer(RECORD_LABEL_LAYER_ID)) {
      map.addLayer(recordLabelLayerDefinition())
    }
  }

  const handleClusterClick = (event) => {
    const map = getMap()
    const feature = event.features?.[0]
    const clusterId = feature?.properties?.cluster_id
    const coordinates = feature?.geometry?.coordinates
    const source = map.getSource(RECORD_SOURCE_ID)
    if (!source || clusterId === undefined || !coordinates) return

    source.getClusterExpansionZoom(clusterId, (error, zoom) => {
      if (error) return

      map.easeTo({ center: coordinates, zoom, duration: 250 })
    })
  }

  const handlePointClick = (event) => {
    const properties = event.features?.[0]?.properties
    if (!properties?.id || !properties?.kind) return

    const record = properties.kind === 'parcel'
      ? getParcels().find((parcel) => String(parcel.id) === String(properties.id))
      : getOpportunities().find((point) => String(point.id) === String(properties.id))
    if (record) onSelectRecord(properties.kind, record)
  }

  return { sync }
}
